import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { useEffect } from "react";
import Interaction from "../../../models/interactions/Interaction";
import { ISetCharacterParts } from "../../../models/interactions/SetCharacterParts";
import {
  selectCachedCharacterPartDetails,
  setCachedCharacterPartDetails,
} from "../../../app/slices/CharacterPartsSlice";
import { CharacterPartService } from "../../../services/CharacterPartService";
import { selectCurrentOrganization } from "../../../app/slices/UserSlice";
import { useDispatch } from "react-redux";

export default function useSetCharacterParts(overrideInteraction?: Interaction) {
  const dispatch = useDispatch();
  const selectedElement = useSelector(selectSelectedElement);
  const interaction = overrideInteraction ?? selectedElement;
  const cached = useSelector(selectCachedCharacterPartDetails);
  const currentOrganization = useSelector(selectCurrentOrganization);

  useEffect(() => {
    const casted = interaction as ISetCharacterParts;

    if (!casted || !casted.partDefinitions || !currentOrganization?.id) return;

    const missingParts = casted.partDefinitions
      .filter((p) => !cached[p.partId])
      .map((p) => p.partId);

    if (missingParts.length === 0) return;

    const loadMissingParts = async () => {
      for (const partId of missingParts) {
        const details = await CharacterPartService.GetCharacterPartGenderedPairDetails(
          currentOrganization.id,
          partId
        );
        if (!details) continue;
        dispatch(
          setCachedCharacterPartDetails({
            characterPartName: partId,
            characterPartDetails: details,
          })
        );
      }
    };

    loadMissingParts();
  }, [interaction, currentOrganization?.id]);
}
